/*

import {initialMeerkeuze} from '@/components/Froala/widgets/';
import {initialKofferVraag} from 'teo_common/components/EditWidgets/KofferVraagEditor';
import {initialKofferVraag2} from 'teo_common/components/EditWidgets/KofferVraagEditor2';
import {initialFileUpload} from 'teo_common/components/EditWidgets/FileUploadEditor';
import {initialInvulVraag} from 'teo_common/components/EditWidgets/InvulVraagEditor';
import {initialOrderVraag} from 'teo_common/components/EditWidgets/OrderVraagEditor';
import {initialLink} from 'teo_common/components/EditWidgets/LinkEditor';
import {initialMatrixVraag2} from 'teo_common/components/EditWidgets/MatrixVraagEditor2';
import {initialNameImage} from 'teo_common/components/EditWidgets/NameImageEditor';
import {initialNameImage2} from 'teo_common/components/EditWidgets/NameImageEditor2';
import {initialMath} from 'teo_common/components/EditWidgets/MathEditor';
import {initialInlineMath} from 'teo_common/components/EditWidgets/MathEditor';
*/

import { config } from '@/config';
import { uploadFile } from '@/query/documents.js';
import { auth } from '@/App';

import { initialOpenVraag } from '@/components/Froala/widgets/OpenQuestionEdit.jsx';

import { initialMeerkeuze } from '@/components/Froala/widgets/MultipleChoiceEdit.jsx';
import { initialKofferVraag2 } from '@/components/Froala/widgets/BoxQuestionEdit.jsx';
import { initialBoxError } from '@/components/Froala/widgets/BoxErrorEdit.jsx';
import { initialKofferVraag } from '@/components/Froala/widgets/BoxQuestionEditOld.jsx';
import { initialFileUpload } from '@/components/Froala/widgets/UploadEdit.jsx';
import { initialInvulVraag } from '@/components/Froala/widgets/InvulVraagEdit.jsx';
import { initialOrderVraag } from '@/components/Froala/widgets/OrderEdit.jsx';
import { initialLink } from '@/components/Froala/widgets/ConnectEdit.jsx';
import { initialMatrixVraag2 } from '@/components/Froala/widgets/MatrixEdit.jsx';
import { initialNameImage2 } from '@/components/Froala/widgets/NamePartsQuestion.jsx';
import {
  initialMath,
  initialInlineMath,
} from '@/components/Froala/widgets/MathEdit.jsx';
import { initialImageShowParts } from '@/components/Froala/widgets/ImageShowPartsEdit';
import { axios } from '@/axios';
import i18n from 'i18next';
import {
  newUid,
  encodeRandomS3URI,
  loadRawScript,
  canAttemptCameraAccess,
} from '@/util';
import { loadIframely } from '@/components/Froala/Froala_iframely';

let froalaPromise;
function initFroala() {
  if (froalaPromise) return froalaPromise;
  froalaPromise = new Promise((resolve, reject) => {
    let styles = [
      'https://unpkg.com/froala-editor@4.5.2/css/froala_editor.pkgd.min.css',
      '/libs/tui-image-editor.min.css?v=20250723',
      'https://unpkg.com/codemirror@5.48.4/lib/codemirror.css',
      'https://unpkg.com/tui-color-picker@2.2.8/dist/tui-color-picker.min.css',
      '/libs/image_tui.min.css?v=20250723',
      'https://cdn.jsdelivr.net/npm/froala-editor@latest/css/plugins/quick_insert.min.css',
    ];
    let scripts = [
      'https://unpkg.com/tui-color-picker@2.2.8/dist/tui-color-picker.min.js',
      'https://unpkg.com/fabric@4.6.0/dist/fabric.min.js',
      '/libs/tui-code-snippet.min.js?v=20250723',
      '/libs/tui-image-editor.min.js?v=20250723',
      'https://unpkg.com/froala-editor@4.5.2/js/froala_editor.pkgd.min.js',
      '/libs/image_tui.min.js?v=20250723',
      'https://unpkg.com/codemirror@5.48.4/lib/codemirror.js',
      'https://unpkg.com/codemirror@5.48.4/mode/xml/xml.js',
      '/libs/froala_line_height.js',
    ];

    if (i18n.language !== 'en') {
      scripts.push('/assets/froala/js/languages/' + i18n.language + '.js');
    }

    window
      .loadjs([...scripts, ...styles], 'froala', {
        async: false,
        returnPromise: true,
      })
      .catch((depsNotFound) => {
        //load local fallbacks
        let fallbacks = depsNotFound.map((x) =>
          x
            .replace(
              'https://unpkg.com/froala-editor@4.5.2/',
              '/libs/froala-editor/'
            )
            .replace(
              'https://unpkg.com/codemirror@5.48.4/',
              '/libs/codemirror/'
            )
            .replace('https://unpkg.com/fabric@4.6.0/', '/libs/fabric/')
            .replace('https://unpkg.com/tui-color-picker@2.2.8/dist/', '/libs/')
        );
        return window.loadjs(fallbacks, 'froala_fallback', {
          async: false,
          returnPromise: true,
        });
      })
      .then((scripts) => {
        return loadRawScript(`
          (function(loadImageFromURL) {
            if (!loadImageFromURL) return;

            window.tui.ImageEditor.prototype.loadImageFromURL = function(url, ...rest) {
              try {
                // Skip timestamp for data URLs
                if (!url.startsWith('data:')) {
                  url += (url.includes('?') ? '&' : '?') + 't=' + Date.now();
                }
                return loadImageFromURL.call(this, url, ...rest);
              } catch (e) {
                console.error('loadImageFromURL override failed:', e);
                return loadImageFromURL.call(this, url, ...rest);
              }
            };
          })(window.tui.ImageEditor.prototype.loadImageFromURL);
        `);
      })
      .then(() => {
        var FroalaEditor = window.FroalaEditor;
        loadIframely();

        FroalaEditor.DefineIcon('MeerKeuze', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('MeerKeuze', {
          icon: `<i class="far fa-check-square"></i>`,
          title: window.i18n.t('widgets.toolbar_button.multiple_choice'),
          focus: true,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialMeerkeuze());
          },
        });

        FroalaEditor.DefineIcon('ChatGPT', { NAME: 'help' });
        FroalaEditor.RegisterQuickInsertButton('ChatGPT', {
          icon: `<img src="/images/icons/chatgpt.svg" alt="chatgpt" class="mt-1.5" />`,
          title: window.i18n.t('widgets.toolbar_button.teo_ai'),
          focus: false,
          undo: true,
          refreshAfterCallback: false,
          callback: function () {
            this.insertChatGpt();
          },
        });
        // FroalaEditor.RegisterCommand('ChatGPT', {
        //   icon: `<i class="far fa-question"></i>`,
        //   title: window.i18n.t('ASK_CHATGPT'),
        //   focus: false,
        //   undo: true,
        //   refreshAfterCallback: false,
        //   callback: async function () {
        //     const api_key =
        //       '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';

        //     let selection = this.selection.text();

        //     let uid = newUid(20);
        //     this.html.insert(`<div style="display: none" id="${uid}"></div>`);

        //     let context = window.$('.fr-view').text();

        //     let userId = localStorage.getItem('userId');
        //     let query = '';
        //     if (context.length > 50) {
        //       query += `Given the following context: ${context}\n`;
        //     }
        //     query += selection;
        //     query = query.slice(-3000);

        //     const data = {
        //       model: 'gpt-3.5-turbo',
        //       messages: [{ role: 'user', content: query }],
        //       user: userId,
        //     };

        //     let response = await axios.post(
        //       'https://chatgpt-api.shn.hk/v1/',
        //       JSON.stringify(data),
        //       {
        //         headers: {
        //           'Content-Type': 'application/json',
        //           Authorization: `Bearer ${api_key}`,
        //         },
        //       }
        //     );
        //     let textData = response.data.choices[0].message.content;
        //     document.getElementById(uid).outerHTML = textData;

        //     //this.html.insert(textData)
        //   },
        // });

        FroalaEditor.DefineIcon('OpenVraag', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('OpenVraag', {
          icon: `<i class="fa fa-question-circle"></i>`,
          title: window.i18n.t('widgets.toolbar_button.open_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialOpenVraag());
          },
        });

        FroalaEditor.DefineIcon('KofferVraag', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('KofferVraag', {
          icon: `<i class="fa fa-suitcase"></i>`,
          title: window.i18n.t('widgets.toolbar_button.box_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialKofferVraag());
          },
        });

        FroalaEditor.DefineIcon('KofferVraag2', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('KofferVraag2', {
          icon: `<i class="fa fa-suitcase"></i>`,
          title: window.i18n.t('widgets.toolbar_button.box_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialKofferVraag2());
          },
        });

        FroalaEditor.DefineIcon('BoxError', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('BoxError', {
          icon: `<i class="fa fa-bug"></i>`,
          title: window.i18n.t('widgets.type.box_error'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialBoxError());
          },
        });

        FroalaEditor.DefineIcon('OrderVraag', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('OrderVraag', {
          icon: `<i class="fas fa-sort"></i>`,
          title: window.i18n.t('widgets.toolbar_button.sorting_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialOrderVraag());
          },
        });

        FroalaEditor.DefineIcon('Link', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('Link', {
          icon: `<i class="fas fa-bezier-curve"></i>`,
          title: window.i18n.t('widgets.toolbar_button.connect_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialLink());
          },
        });

        FroalaEditor.DefineIcon('MatrixVraag2', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('MatrixVraag2', {
          icon: `<i class="far fa-clipboard-list"></i>`,
          title: window.i18n.t('widgets.toolbar_button.matrix_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialMatrixVraag2());
          },
        });

        /*
        FroalaEditor.DefineIcon('NameImage', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('NameImage', {
          icon: `<i class="far fa-tags"></i>`,
          title: 'Name the parts',
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialNameImage());
          },
        });
        */

        FroalaEditor.DefineIcon('NameImage2', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('NameImage2', {
          icon: `<i class="far fa-tags"></i>`,
          title: window.i18n.t('widgets.toolbar_button.name_parts_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialNameImage2());
          },
        });

        FroalaEditor.DefineIcon('InvulVraag', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('InvulVraag', {
          icon: `<i class="far fa-file-invoice"></i>`,
          title: window.i18n.t('widgets.toolbar_button.fill_n_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialInvulVraag());
          },
        });

        FroalaEditor.DefineIcon('FileUpload', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('FileUpload', {
          icon: `<i class="fas fa-cloud-upload"></i>`,
          title: window.i18n.t('widgets.toolbar_button.upload_question'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialFileUpload());
          },
        });

        FroalaEditor.DefineIcon('Math', { NAME: 'math' });
        FroalaEditor.RegisterCommand('Math', {
          icon: `<i class="far fa-function"></i>`,
          title: window.i18n.t('widgets.toolbar_button.formula'),
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialMath());
          },
        });

        FroalaEditor.DefineIcon('InlineMath', { NAME: 'math' });
        FroalaEditor.RegisterCommand('InlineMath', {
          icon: `<b style="margin: 8px 7px; font-size: 24px; display: block; transform: translateY(-1.5px);">&pi;</b>`,
          title: 'Inline formula',
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertInlineWidget(this, initialInlineMath());
          },
        });

        FroalaEditor.DefineIcon('moreQuiz', {
          NAME: 'ellipsis-v',
          SVG_KEY: 'insertMore',
        });
        FroalaEditor.RegisterCommand('moreQuiz', {
          icon: '<i class="fa fa-question-circle"></i>',
          title: 'More Custom Stuff',
          undo: false,
          more_btn: false,
          callback: function (cmd) {
            this.moreExec(cmd);
          },
        });

        FroalaEditor.DefineIcon('save', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('save', {
          icon: `<i class="far fa-save"></i>`,
          title: 'Save',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: function () {
            if (this) this.save_cb();
          },
        });

        FroalaEditor.DefineIcon('placeholder', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('placeholder', {
          icon: `<i class="far fa-question-square"></i>`,
          title: 'Placeholder',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: function () {
            let uid = newUid(20);
            this.undo.saveStep();
            this.html.insert(
              `<span id=${uid} class="invulvraag_placeholder"></span>&nbsp;`
            );
            this.placeholder_cb(uid);
          },
        });

        FroalaEditor.DefineIcon('pagebreak', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('pagebreak', {
          icon: `<img src='data:image/svg+xml;base64,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'/>`,
          title: 'Page break',
          focus: false,
          undo: true,
          refreshAfterCallback: false,
          callback: function () {
            this.html.insert(
              '<div class=\'pageBreak fr-deletable\' contenteditable=false style="width: 100%; height: 20px; border-bottom: 1px solid black; text-align: center;  ">\n' +
                '  <span   class=\'btn-prim\' style="top: 4px; opacity:100%; ">\n' +
                '    Page Break' +
                '  </span>\n' +
                '</div><br/>'
            );
          },
        });

        FroalaEditor.DefineIcon('imageLibrary', {
          NAME: 'folder',
          SVG_KEY: 'imageManager',
        });

        FroalaEditor.RegisterCommand('imageLibrary', {
          icon: `<i class="far fa-books" style="margin: 8px 11px; font-size: 15px; height: 20px;" ></i>`,
          title: 'TEO image library',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: function () {
            this.insertLibrary();
          },
        });

        FroalaEditor.RegisterQuickInsertButton('imageLibraryHelp', {
          icon: `<i class="far fa-books" style="font-size: 15px; height: 20px; transform: translateY(-7px)" ></i>`,
          title: 'TEO image library',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: function () {
            this.insertLibrary();
          },
        });

        FroalaEditor.RegisterQuickInsertButton('videoLeft', {
          icon: `<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,8v8H5V8H15m2,2.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l2.29,2.29A1,1,0,0,0,21,15.08V8.91a1,1,0,0,0-1.71-.71Z"></path></svg>`,
          title: 'Video',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: async function () {
            const frtoolbar = document.querySelector('.fr-toolbar');
            let left = 50;
            let top = 0;
            if (frtoolbar) {
              top = frtoolbar.getBoundingClientRect().height;
            }
            await this.commands.exec('insertVideo');
            const $popup = this.popups.get('video.insert');

            if ($popup) {
              $popup.css({
                top: top - 5 + 'px',
                left: left + '%',
                transform: 'translateX(-50%)',
              });
            }
          },
        });

        canAttemptCameraAccess().then(() => {
          FroalaEditor.DefineIcon('imageByCamera', { NAME: 'plus' });
          FroalaEditor.RegisterCommand('imageByCamera', {
            icon: `<i class="far fa-camera" style="font-size: 19px; height: 20px;" ></i>`,
            title: 'Upload from camera',
            focus: false,
            undo: false,
            refreshAfterCallback: false,
            callback: function () {
              this.insertCamera();
            },
          });
        });

        canAttemptCameraAccess().then(() => {
          FroalaEditor.DefineIcon('videoByCamera', { NAME: 'plus' });
          FroalaEditor.RegisterCommand('videoByCamera', {
            icon: `<i class="far fa-camera" style="font-size: 19px; height: 20px;" ></i>`,
            title: 'Upload from camera',
            focus: false,
            undo: false,
            refreshAfterCallback: false,
            callback: function () {
              this.insertVideoCamera();
            },
          });
        });

        FroalaEditor.DefineIcon('drawIoLink', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('drawIoLink', {
          icon: `<i class="far fa-draw-polygon" style="font-size: 19px; height: 20px;" ></i>`,
          title: 'Create a drawIo link that opens a schematic by default',
          focus: false,
          undo: false,
          refreshAfterCallback: false,
          callback: function () {
            this.insertDrawIoLink();
          },
        });

        FroalaEditor.DefineIcon('MathDropdown', { NAME: 'function' });
        FroalaEditor.RegisterCommand('MathDropdown', {
          icon: `<i class="far fa-function"></i>`,
          title: window.i18n.t('widgets.toolbar_button.formula'),
          type: 'dropdown',
          focus: false,
          undo: false,
          refreshAfterCallback: true,
          options: {
            formula: 'Block',
            inline: 'Inline',
          },
          callback: function (cmd, val) {
            switch (val) {
              case 'formula':
                FroalaEditor.COMMANDS.Math.callback.call(this);
                break;
              case 'inline':
                FroalaEditor.COMMANDS.InlineMath.callback.call(this);
                break;
            }
          },
        });

        FroalaEditor.DefineIcon('Phet', { NAME: 'phet' });
        FroalaEditor.RegisterCommand('Phet', {
          icon: `<i class="far fa-lightbulb-on"></i>`,
          title: 'Phet',
          type: 'dropdown',
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          uid: newUid(20),
          content: async function () {
            var uid = FroalaEditor.COMMANDS.Phet.uid;
            let placeholder = document.getElementById(uid);
            const promises = [];
            const result = await axios.get(
              `${config.backend}/courseassets?assetType=phet&lang=${i18n.language}&organisationId=${auth?.user?.activeOrganisationId},OR,organisationId=null`
            );
            promises.push(result);
            Promise.allSettled(promises).then(() => {
              if (result) {
                var c =
                  '<ul class="fr-dropdown-list max-w-[280px]" role="presentation">';
                for (var cls in result?.data) {
                  var option = result?.data[cls];
                  c +=
                    "<li role='presentation'><a class='fr-command !whitespace-normal !px-6 !py-1 !leading-normal' tabIndex='-1' role='option' data-cmd='Phet' data-param1=" +
                    option?.id +
                    '>' +
                    option.assetTitle +
                    '</a></li>';
                }

                c += '</ul>';
                placeholder.innerHTML = c;
              }
            });
          },
          html: function html() {
            var uid = FroalaEditor.COMMANDS.Phet.uid;
            var c = `<div id="${uid}"></div>`;
            setTimeout(() => {
              FroalaEditor.COMMANDS.Phet.content.call(this);
            }, 1500);
            return c;
          },
          callback: async function (cmd, val) {
            await axios
              .get(
                `${config.backend}/courseassets?assetType=phet&lang=${i18n.language}&organisationId=${auth?.user?.activeOrganisationId},OR,organisationId=null`
              )
              .then((results) => {
                results.data?.map(
                  (el) => el?.id == val && this.insertPhet(el?.embed)
                );
              });
          },
        });

        FroalaEditor.DefineIcon('formatULSimple', {
          NAME: 'list-ul',
          SVG_KEY: 'unorderedList',
        });
        FroalaEditor.RegisterCommand('formatULSimple', {
          title: 'Unordered List',
          type: 'button',
          options: {
            default: 'Default',
            circle: 'Circle',
            disc: 'Disc',
            square: 'Square',
          },
          refresh: function refresh($btn) {
            this.lists.refresh($btn, 'UL');
          },
          callback: function callback(cmd, param) {
            this.lists.format('UL', param);
          },
          plugin: 'lists',
        }); // Register the font size command.

        FroalaEditor.DefineIcon('ImageShowParts', { NAME: 'plus' });
        FroalaEditor.RegisterCommand('ImageShowParts', {
          icon: `<img src="/images/icons/AnnotatedImage-outline.svg" alt="chatgpt" class="!w-5" />`,
          title: 'Name the parts',
          focus: false,
          undo: true,
          refreshAfterCallback: true,
          callback: function () {
            this.insertWidget(this, initialImageShowParts());
          },
        });

        /*
        FroalaEditor.DefineIcon('3D', {NAME: 'plus'});
        FroalaEditor.RegisterCommand('3D', {
            icon: `<i class="far fa-cube"></i>`,
            title: '3D model',
            focus: false,
            undo: true,
            refreshAfterCallback: true,
            callback: function () {
              this.insertEmbedWidget(this, initial3D());
            }
        });
        */

        FroalaEditor.POPUP_TEMPLATES['d3Plugin.popup'] =
          '[_BUTTONS_][_CUSTOM_LAYER_]';

        // Define popup buttons.
        Object.assign(FroalaEditor.DEFAULTS, {
          popupButtons: ['d3UploadButton'],
        });

        // The custom popup is defined inside a plugin (new or existing).
        FroalaEditor.PLUGINS.d3Plugin = function (editor) {
          let origEditor = editor;
          var $ = editor.$;
          // Create custom popup.
          function initPopup() {
            // Popup buttons.
            var popup_buttons = '';

            // Create the list of buttons.
            if (editor.opts.popupButtons.length > 1) {
              popup_buttons += '<div class="fr-buttons">';
              popup_buttons += editor.button.buildList(
                editor.opts.popupButtons
              );
              popup_buttons += '</div>';
            }

            let upload_layer = `<div class="fr-video-upload-layer fr-layer fr-active" id="fr-video-upload-layer-1" data-mouseenter-event-set="true"><strong>Sleep 3D model</strong><br>(of klik op)<div class="fr-form"><input type="file" accept="*" tabindex="-1" aria-labelledby="fr-video-upload-layer-1" role="button" dir="ltr" class=""></div></div>`;

            // Load popup template.
            var template = {
              buttons: popup_buttons,
              custom_layer: upload_layer,
            };

            // Create popup.
            var $popup = editor.popups.create('d3Plugin.popup', template);

            _bindInsertEvents($popup);

            return $popup;
          }

          // Show the popup
          function showPopup() {
            // Get the popup object defined above.
            var $popup = editor.popups.get('d3Plugin.popup');

            // If popup doesn't exist then create it.
            // To improve performance it is best to create the popup when it is first needed
            // and not when the editor is initialized.
            if (!$popup) $popup = initPopup();

            // Set the editor toolbar as the popup's container.
            editor.popups.setContainer('d3Plugin.popup', editor.$tb);

            // This will trigger the refresh event assigned to the popup.
            // editor.popups.refresh('d3Plugin.popup');

            // This custom popup is opened by pressing a button from the editor's toolbar.
            // Get the button's object in order to place the popup relative to it.
            var $btn = editor.$tb.find('.fr-command[data-cmd="3D"]');

            // Set the popup's position.
            var left = $btn.offset().left + $btn.outerWidth() / 2;
            var top =
              $btn.offset().top +
              (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);

            // Show the custom popup.
            // The button's outerHeight is required in case the popup needs to be displayed above it.
            editor.popups.show('d3Plugin.popup', left, top, $btn.outerHeight());
          }

          // Hide the custom popup.
          function hidePopup() {
            editor.popups.hide('d3Plugin.popup');
          }

          function upload(files) {
            //editor.selection.save();
            hidePopup();

            for (let file of files) {
              let path = encodeRandomS3URI('upload/' + file.name);
              uploadFile(path, file).then((url) => {
                editor.html.insert(
                  `
                  <span class="fr-video fr-deletable fr-draggable" contenteditable="false" draggable="true" style="display: block; clear: both; text-align: center;">
                    <iframe src="https://gltf-viewer.donmccurdy.com#kiosk=true&model=${url}" frameBorder="0" style={{width: 'calc(min(100%,800px))', height: '500px'}}></iframe>
                  </span>`,
                  false
                );
              });
            }
          }

          function _bindInsertEvents($popup) {
            // Drag over the dropable area.
            editor.events.$on(
              $popup,
              'dragover dragenter',
              '.fr-video-upload-layer',
              function () {
                $(this).addClass('fr-drop');
                return false;
              },
              true
            ); // Drag end.

            editor.events.$on(
              $popup,
              'dragleave dragend',
              '.fr-video-upload-layer',
              function () {
                $(this).removeClass('fr-drop');
                return false;
              },
              true
            ); // Drop.

            editor.events.$on(
              $popup,
              'drop',
              '.fr-video-upload-layer',
              function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).removeClass('fr-drop');
                var dt = e.originalEvent.dataTransfer;

                if (dt && dt.files) {
                  var inst = $popup.data('instance') || editor;
                  inst.events.disableBlur();
                  //inst.video.upload(dt.files);
                  upload(dt.files);
                  inst.events.enableBlur();
                }
              },
              true
            );

            if (editor.helpers.isIOS()) {
              editor.events.$on(
                $popup,
                'touchstart',
                '.fr-video-upload-layer input[type="file"]',
                function () {
                  $(this).trigger('click');
                },
                true
              );
            }

            editor.events.$on(
              $popup,
              'change',
              '.fr-video-upload-layer input[type="file"]',
              function () {
                if (this.files) {
                  var inst = $popup.data('instance') || editor;
                  inst.events.disableBlur();
                  $popup.find('input:focus').blur();
                  inst.events.enableBlur();
                  //inst.video.upload(this.files);
                  upload(this.files);
                } // Else IE 9 case.
                // Chrome fix.

                $(this).val('');
              },
              true
            );
          }

          // Methods visible outside the plugin.
          return {
            showPopup: showPopup,
            hidePopup: hidePopup,
          };
        };

        FroalaEditor.PLUGINS.draggable = function (editor) {
          var $ = editor.$;

          function _dragStart(e) {
            if (!$(e.target).hasClass('fr-draggable')) {
              e.preventDefault();
              return false;
            }
          }

          function _init() {
            // Force drag inline when ENTER_BR is active.
            if (editor.opts.enter === FroalaEditor.ENTER_BR)
              editor.events.on('dragstart', _dragStart, true); // Inline dragging is off.
          }

          return {
            _init: _init,
          };
        };

        // Define an icon and command for the button that opens the custom popup.
        FroalaEditor.DefineIcon('3D', { NAME: 'star', SVG_KEY: 'star' });
        FroalaEditor.RegisterCommand('3D', {
          title: '3D model',
          icon: `<i class="far fa-cube"></i>`,
          undo: false,
          focus: false,
          plugin: 'd3Plugin',
          callback: function () {
            this.d3Plugin.showPopup();
          },
        });

        FroalaEditor.DefineIcon('d3UploadButton', {
          NAME: 'bell-o',
          SVG_KEY: 'help',
        });
        FroalaEditor.RegisterCommand('d3UploadButton', {
          icon: `<i class="fas fa-upload" aria-hidden="true"></i>`,
          title: 'Upload modal',
          undo: false,
          focus: false,
          callback: function () {
            alert('d3UploadButton was pressed');
          },
        });

        FroalaEditor.VIDEO_EMBED_REGEX = /.*/im;
        FroalaEditor.DEFAULTS.htmlAllowedTags.push('i', 'a');
        FroalaEditor.RegisterShortcut(83, 'save', null, 'S');
        resolve();
      })
      .catch(reject);
  });
  return froalaPromise;
}

export { initFroala };
